import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import OwlCarousel from 'react-owl-carousel'
import BGImg1 from '../../assets/images/background/slider-1-1.jpg'
import BGImg2 from '../../assets/images/background/slider-1-2.jpg'
import BGImg3 from '../../assets/images/shapes/service-four-bg-1-1.png'
import BGImg7 from '../../assets/images/shapes/about-three-s-1.png'
import img2 from '../../assets/images/resources/about-five-1-2.jpg'
import img3 from "../../assets/images/resources/about-three-1-1.jpg";
import { useTranslation } from 'react-i18next';

const Home = () => {
  const { t, i18n } = useTranslation();
    const [ytShow, setytShow] = useState(false)
    const options = {
        loop: false,
        margin: 0,
        responsiveClass: true,
        nav: false,
        dots: false,
        autoplay: false,
        items: 1,
        smartSpeed: 700,
        responsive: {
            0: {
                margin: 0,
                items: 1
            },
            576: {
                margin: 30,
                items: 2
            },
            768: {
                margin: 30,
                items: 3
            },
            992: {
                margin: 30,
                items: 4
            },
            1200: {
                margin: 30,
                items: 5
            }
        },
    };
    const sliderOptions = {
        loop: true,
        items: 1,
        navText: ["<span class=\"fa-solid fa-angle-left\"></span>", "<span class=\"fa-solid fa-angle-right\"></span>"],
        margin: 0,
        dots: true,
        nav: true,
        animateOut: "slideOutDown",
        animateIn: "fadeIn",
        smartSpeed: 1000,
        autoplay: true,
        autoplayTimeout: 7000,
        autoplayHoverPause: false
    }

  
    return (
      <>
        <div className="slider-one" dir="ltr">
          <OwlCarousel
            key={`slider-${i18n.language}`}
            className="slider-one__carousel owl-theme thm-owl__carousel"
            {...sliderOptions}
          >
            <div className="item slider-one__slide-1">
              <div
                className="slider-one__bg"
                style={{ backgroundImage: `url(${BGImg1})` }}
              ></div>
              <div className="slider-one__line"></div>
              <div className="slider-one__shape-1"></div>
              <div className="slider-one__shape-2"></div>
              <div className="slider-one__shape-3"></div>
              <div className="container">
                <div className="slider-one__content ">
                  <div className="slider-one__floated lettering-text">
                    {t('home_page.tech')}
                  </div>
                  <p className="slider-one__text">
                    {t('home_page.welcome_txt')}
                  </p>
                  <div className="slider-one__title-wrapper">
                    <h2 className="slider-one__title">
                      {t('home_page.our_intellegent')} <br />
                      {t('home_page.techno')}
                      <br />
                      {t('home_page.creations')}
                    </h2>
                  </div>
                  <div className="slider-one__btns">
                    <Link to="/about" className="thm-btn slider-one__btn">
                      <span>{t('home_page.learn_more')}</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="item slider-one__slide-2">
              <div
                className="slider-one__bg"
                style={{ backgroundImage: `url(${BGImg2})` }}
              ></div>
              <div className="slider-one__line"></div>
              <div className="slider-one__shape-1"></div>
              <div className="slider-one__shape-2"></div>
              <div className="slider-one__shape-3"></div>
              <div className="container">
                <div className="slider-one__content ">
                  <div className="slider-one__floated lettering-text">
                    {t('home_page.tech')}
                  </div>
                  <p className="slider-one__text">
                    {t('home_page.welcome_txt')}
                  </p>
                  <div className="slider-one__title-wrapper">
                    <h2 className="slider-one__title">
                      {t('home_page.our_intellegent')} <br />
                      {t('home_page.techno')} <br />
                      {t('home_page.solution')}
                    </h2>
                  </div>
                  <div className="slider-one__btns">
                    <Link to="/about" className="thm-btn slider-one__btn">
                      <span>{t('home_page.learn_more')}</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </OwlCarousel>
        </div>

        <section className="section-padding--bottom section-padding--top about-five">
          <div className="container">
            <div className="row gutter-y-60">
              <div className="col-lg-6">
                <div className="about-five__images">
                  <div className="about-five__images__shape"></div>
                  <img
                    src={img2}
                    className="wow fadeInUp"
                    data-wow-duration="1500ms"
                    alt=""
                  />
                  {/* <img src={img2} alt="" /> */}
                  {/* <div className="about-five__video">
                    <Link
                      to="#"
                      onClick={() => setytShow(true)}
                      className="video-popup"
                    >
                      <i className="fa fa-play"></i>
                    </Link>
                  </div> */}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="about-five__content">
                  <div className="section-title ">
                    <p className="section-title__text">{t('home_page.about_com')}</p>
                    <h2 className="section-title__title">
                      {t('home_page.title')}
                    </h2>
                  </div>
                  <div className="about-five__text">
                    {t('home_page.home_para_1')}
                  </div>
                  <div className="about-five__text">
                    {t('home_page.home_para_2')}
                  </div>
                  <ul className="about-five__box">
                    <li className="about-five__box__item gray-bg">
                      <i className="about-five__box__icon icon-consulting"></i>
                      <div className="about-five__box__content">
                        <h3 className="about-five__box__title">
                          <Link to="/it-consultent">{t('home_page.it_con')}</Link>
                        </h3>
                        <p className="about-five__box__text">
                          {t('home_page.smarter_sol')}
                        </p>
                      </div>
                    </li>
                    <li className="about-five__box__item gray-bg">
                      <i className="about-five__box__icon icon-chip"></i>
                      <div className="about-five__box__content">
                        <h3 className="about-five__box__title">
                          <Link to="/team">{t('home_page.it_spl')}</Link>
                        </h3>
                        <p className="about-five__box__text">
                          {t('home_page.faster_sol')}
                        </p>
                      </div>
                    </li>
                  </ul>
                  <div className="about-four__meta">
                    {/* <div className="about-four__author">
                      <img
                        src="assets/images/resources/about-four-author-1.jpg"
                        alt=""
                      />
                      <div className="about-four__author__content">
                        <h3 className="about-four__author__title">
                          Michele Morrone
                        </h3>
                        <div className="about-four__author__designation">
                          Founder CEO
                        </div>
                      </div>
                    </div> */}
                    <Link to="/about" className="thm-btn about-four__btn">
                      <span>{t('home_page.learn_more')}</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className=" section-padding--top service-four gray-bg section-padding-xl--bottom section-has-bottom-margin background-repeat-no background-position-top-right"
          style={{ backgroundImage: `url(${BGImg3})` }}
        >
          <div className="container">
            <div className="section-title text-center">
              <p className="section-title__text">{t('home_page.pop_serv')}</p>
              <h2 className="section-title__title">
                {t('home_page.title_txt_1')} <br />
                {t('home_page.title_txt_2')}
              </h2>
            </div>
            <OwlCarousel
              key={`services-${i18n.language}`}
              className="thm-owl__carousel thm-owl__carousel--with-shadow service-four__carousel"
              {...options}
            >
              <div className="item">
                <div className="service-card-three">
                  <div className="service-card-three__icon">
                    <i className="icon-new-product"></i>
                  </div>
                  <div className="service-card-three__content">
                    <h3 className="service-card-three__title">
                      <Link to="/infrastructure-plan">
                        {t('home_page.prod')}
                        <br />
                        {t('home_page.develop')}
                      </Link>
                    </h3>
                    <div className="service-card-three__text">
                      {t('home_page.title_txt_3')}
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="service-card-three">
                  <div className="service-card-three__icon">
                    <i className="icon-new-product"></i>
                  </div>
                  <div className="service-card-three__content">
                    <h3 className="service-card-three__title">
                      <Link to="/infrastructure-plan">
                        {t('home_page.digital')}
                        <br />
                        {t('home_page.market')}
                      </Link>
                    </h3>
                    <div className="service-card-three__text">
                      {t('home_page.title_txt_3')}
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="service-card-three">
                  <div className="service-card-three__icon">
                    <i className="icon-protection"></i>
                  </div>
                  <div className="service-card-three__content">
                    <h3 className="service-card-three__title">
                      <Link to="/infrastructure-plan">
                        {t('home_page.security')} <br />
                        {t('home_page.sys')}
                      </Link>
                    </h3>
                    <div className="service-card-three__text">
                      {t('home_page.title_txt_3')}
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="service-card-three">
                  <div className="service-card-three__icon">
                    <i className="icon-web-development"></i>
                  </div>
                  <div className="service-card-three__content">
                    <h3 className="service-card-three__title">
                      <Link to="/infrastructure-plan">
                        {t('home_page.ui_ux')}
                        <br />
                        {t('home_page.design')}
                      </Link>
                    </h3>
                    <div className="service-card-three__text">
                      {t('home_page.title_txt_3')}
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="service-card-three">
                  <div className="service-card-three__icon">
                    <i className="icon-analysis"></i>
                  </div>
                  <div className="service-card-three__content">
                    <h3 className="service-card-three__title">
                      <Link to="/infrastructure-plan">
                        {t('home_page.data')}
                        <br />
                        {t('home_page.analysis')}
                      </Link>
                    </h3>
                    <div className="service-card-three__text">
                      {t('home_page.title_txt_3')}
                    </div>
                  </div>
                </div>
              </div>
            </OwlCarousel>
          </div>
        </section>

        <section
          className=" section-padding--top service-four gray-bg section-padding-xl--bottom section-has-bottom-margin background-repeat-no background-position-top-right"
          style={{ backgroundImage: `url(${BGImg3})` }}
        >
        </section>

        {/* <section className="section-padding--bottom section-padding--top project-one">
          <div className="container">
            <div className="project-one__top">
              <div className="row">
                <div className="col-lg-7">
                  <div className="section-title ">
                    <p className="section-title__text">Latest Project</p>
                    <h2 className="section-title__title">
                      Check We Have Solution <br />
                      Done IT Project
                    </h2>
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="project-one__top__content">
                    <p className="project-one__top__text">
                      Pellentesque Viverra Eget Velit A Tincidunt. Sed Mattis
                      Enim Nisl, Sit Amet Malesuada Sapien Pulvinar Ut.
                    </p>
                    <div className="project-one__top__btns">
                      <Link
                        to="/projects"
                        className="thm-btn project-one__top__btn"
                      >
                        <span>View All Projects</span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <OwlCarousel
              key={`projects-${i18n.language}`}
              className="thm-owl__carousel project-one__carousel thm-owl__carousel--with-shadow"
              {...projectOptions}
            >
              <div className="item">
                <div className="project-card-one">
                  <div className="project-card-one__image">
                    <img src="assets/images/projects/project-1-1.jpg" alt="" />
                  </div>
                  <div className="project-card-one__content">
                    <div className="project-card-one__content__inner">
                      <p className="project-card-one__text">
                        IT Technology Solution
                      </p>
                      <h3 className="project-card-one__title">
                        <Link to="/project-details">
                          Data Recovery Analysis
                        </Link>
                      </h3>
                      <Link
                        to="/project-details"
                        className="project-card-one__more"
                      >
                        <i className="fa fa-angle-right"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="project-card-one">
                  <div className="project-card-one__image">
                    <img src="assets/images/projects/project-1-2.jpg" alt="" />
                  </div>
                  <div className="project-card-one__content">
                    <div className="project-card-one__content__inner">
                      <p className="project-card-one__text">
                        IT Technology Solution
                      </p>
                      <h3 className="project-card-one__title">
                        <Link to="/project-details">
                          Data Recovery Analysis
                        </Link>
                      </h3>
                      <Link
                        to="/project-details"
                        className="project-card-one__more"
                      >
                        <i className="fa fa-angle-right"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="project-card-one">
                  <div className="project-card-one__image">
                    <img src="assets/images/projects/project-1-3.jpg" alt="" />
                  </div>
                  <div className="project-card-one__content">
                    <div className="project-card-one__content__inner">
                      <p className="project-card-one__text">
                        IT Technology Solution
                      </p>
                      <h3 className="project-card-one__title">
                        <Link to="/project-details">
                          Data Recovery Analysis
                        </Link>
                      </h3>
                      <Link
                        to="/project-details"
                        className="project-card-one__more"
                      >
                        <i className="fa fa-angle-right"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="project-card-one">
                  <div className="project-card-one__image">
                    <img src="assets/images/projects/project-1-4.jpg" alt="" />
                  </div>
                  <div className="project-card-one__content">
                    <div className="project-card-one__content__inner">
                      <p className="project-card-one__text">
                        IT Technology Solution
                      </p>
                      <h3 className="project-card-one__title">
                        <Link to="/project-details">
                          Data Recovery Analysis
                        </Link>
                      </h3>
                      <Link
                        to="/project-details"
                        className="project-card-one__more"
                      >
                        <i className="fa fa-angle-right"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="project-card-one">
                  <div className="project-card-one__image">
                    <img src="assets/images/projects/project-1-5.jpg" alt="" />
                  </div>
                  <div className="project-card-one__content">
                    <div className="project-card-one__content__inner">
                      <p className="project-card-one__text">
                        IT Technology Solution
                      </p>
                      <h3 className="project-card-one__title">
                        <Link to="/project-details">
                          Data Recovery Analysis
                        </Link>
                      </h3>
                      <Link
                        to="/project-details"
                        className="project-card-one__more"
                      >
                        <i className="fa fa-angle-right"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="project-card-one">
                  <div className="project-card-one__image">
                    <img src="assets/images/projects/project-1-6.jpg" alt="" />
                  </div>
                  <div className="project-card-one__content">
                    <div className="project-card-one__content__inner">
                      <p className="project-card-one__text">
                        IT Technology Solution
                      </p>
                      <h3 className="project-card-one__title">
                        <Link to="/project-details">
                          Data Recovery Analysis
                        </Link>
                      </h3>
                      <Link
                        to="/project-details"
                        className="project-card-one__more"
                      >
                        <i className="fa fa-angle-right"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </OwlCarousel>
          </div>
        </section> */}

        {/* <section class="black-bg cta-two">
          <Parallax
            bgImage={BGImg}
            bgImageAlt=""
            className="section-padding-lg--top section-padding-lg--bottom"
            strength={1000}
          >
            <div className="container">
              <div className="cta-two__inner">
                <h3 className="cta-two__title">
                  Better IT Solutions And Services At Your{" "}
                  <span>Fingertips</span>
                </h3>
                <Link to="/contact" className="thm-btn cta-two__btn">
                  <span>LEarn More</span>
                </Link>
              </div>
            </div>
          </Parallax>
        </section> */}

        {/* <section
          className="section-padding--bottom section-padding--top testimonials-two background-repeat-no background-position-top-center"
          style={{ backgroundImage: `url(${BGImg5})` }}
        >
          <div className="container">
            <div className="row gutter-y-60">
              <div className="col-lg-5">
                <div className="testimonials-two__content">
                  <div className="section-title ">
                    <p className="section-title__text">Our clients</p>
                    <h2 className="section-title__title">
                      We Are Trusted Worldwide Peoples
                    </h2>
                  </div>
                  <div className="testimonials-two__content__text">
                    Sed ut perspiciatis unde omnis natus error sit voluptatem
                    accusa ntium doloremque laudantium totam rem aperiamea
                    queipsa quae abillo inventore veritatis et quasi architecto
                    beatae vitae dicta sunt explicabo.
                  </div>
                  <div className="testimonials-two__content__text">
                    Pellentesque gravida lectus vitae nisi luctus, Finibus
                    aliquet ligula ultrices.
                  </div>
                  <Link
                    to="/about"
                    className="thm-btn testimonials-two__content__btn"
                  >
                    <span>View All feedbacks</span>
                  </Link>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="testimonials-two__items">
                  <div className="row gutter-y-30">
                    <div className="col-lg-12">
                      <div className="testimonials-one-card">
                        <div className="testimonials-one-card__image">
                          <img
                            src="assets/images/resources/testi-1-1.jpg"
                            alt=""
                          />
                        </div>
                        <div className="testimonials-one-card__content">
                          <div className="testimonials-one-card__text">
                            On the other hand denounc with ghteo indignation and
                            dislike men who so beguiled and demoralized the
                            charms of pleasure the momen blinded by desire
                            cannot foresee the pain and trouble.
                          </div>
                          <h3 className="testimonials-one-card__title">
                            Michal Rahul
                          </h3>
                          <p className="testimonials-one-card__designation">
                            Ul - UX Designer
                          </p>

                          <i className="icon-right-quote testimonials-one-card__icon"></i>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="testimonials-one-card">
                        <div className="testimonials-one-card__image">
                          <img
                            src="assets/images/resources/testi-1-2.jpg"
                            alt=""
                          />
                        </div>
                        <div className="testimonials-one-card__content">
                          <div className="testimonials-one-card__text">
                            On the other hand denounc with ghteo indignation and
                            dislike men who so beguiled and demoralized the
                            charms of pleasure the momen blinded by desire
                            cannot foresee the pain and trouble.
                          </div>
                          <h3 className="testimonials-one-card__title">
                            Jessica Brown
                          </h3>
                          <p className="testimonials-one-card__designation">
                            Ul - UX Designer
                          </p>
                          <i className="icon-right-quote testimonials-one-card__icon"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        {/* <div className="client-carousel client-carousel--two">
          <div className="container">
            <OwlCarousel className="thm-owl__carousel" {...logoOptions}>
              <div className="item">
                <img src={cl1} alt="" />
              </div>
              <div className="item">
                <img src={cl2} alt="" />
              </div>
              <div className="item">
                <img src={cl3} alt="" />
              </div>
              <div className="item">
                <img src={cl4} alt="" />
              </div>
              <div className="item">
                <img src={cl5} alt="" />
              </div>
              <div className="item">
                <img src={cl6} alt="" />
              </div>
              <div className="item">
                <img src={cl7} alt="" />
              </div>
              <div className="item">
                <img src={cl8} alt="" />
              </div>
            </OwlCarousel>
          </div>
        </div> */}
        {/* <section
          className="section-padding--bottom section-padding--top gray-bg background-size-cover"
          style={{ backgroundImage: `url(${BGImg6})` }}
        >
          <div className="container">
            <div className="section-title text-center">
              <p className="section-title__text">Our Team members</p>
              <h2 className="section-title__title">
                Our Expert Person to Provide <br /> IT Solution Services
              </h2>
            </div>
            <div className="row gutter-y-30">
              <div className="col-lg-3 col-md-6 col-sm-12">
                <div
                  className="team-card-one wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="000ms"
                >
                  <div className="team-card-one__image">
                    <img src="assets/images/team/team-2-1.jpg" alt="" />
                    <div className="team-card-one__social">
                      <ul className="team-card-one__social__links">
                        <li>
                          <Link to="#">
                            <i className="fab fa-twitter"></i>
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-facebook"></i>
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-pinterest-p"></i>
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-instagram"></i>
                          </Link>
                        </li>
                      </ul>
                      <div className="team-card-one__social__icon">
                        <i className="fa fa-share-alt"></i>
                      </div>
                    </div>
                  </div>
                  <div className="team-card-one__content">
                    <h3 className="team-card-one__title">
                      <Link to="#">Michelle Monaghan</Link>
                    </h3>

                    <p className="team-card-one__designation">Designer</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12">
                <div
                  className="team-card-one wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="100ms"
                >
                  <div className="team-card-one__image">
                    <img src="assets/images/team/team-2-2.jpg" alt="" />
                    <div className="team-card-one__social">
                      <ul className="team-card-one__social__links">
                        <li>
                          <Link to="#">
                            <i className="fab fa-twitter"></i>
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-facebook"></i>
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-pinterest-p"></i>
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-instagram"></i>
                          </Link>
                        </li>
                      </ul>
                      <div className="team-card-one__social__icon">
                        <i className="fa fa-share-alt"></i>
                      </div>
                    </div>
                  </div>
                  <div className="team-card-one__content">
                    <h3 className="team-card-one__title">
                      <Link to="#">Jessica Brown</Link>
                    </h3>

                    <p className="team-card-one__designation">Manager</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12">
                <div
                  className="team-card-one wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="200ms"
                >
                  <div className="team-card-one__image">
                    <img src="assets/images/team/team-2-3.jpg" alt="" />
                    <div className="team-card-one__social">
                      <ul className="team-card-one__social__links">
                        <li>
                          <Link to="#">
                            <i className="fab fa-twitter"></i>
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-facebook"></i>
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-pinterest-p"></i>
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-instagram"></i>
                          </Link>
                        </li>
                      </ul>
                      <div className="team-card-one__social__icon">
                        <i className="fa fa-share-alt"></i>
                      </div>
                    </div>
                  </div>
                  <div className="team-card-one__content">
                    <h3 className="team-card-one__title">
                      <Link to="#">Kevin Martin</Link>
                    </h3>

                    <p className="team-card-one__designation">Developer</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12">
                <div
                  className="team-card-one wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="team-card-one__image">
                    <img src="assets/images/team/team-2-4.jpg" alt="" />
                    <div className="team-card-one__social">
                      <ul className="team-card-one__social__links">
                        <li>
                          <Link to="#">
                            <i className="fab fa-twitter"></i>
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-facebook"></i>
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-pinterest-p"></i>
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-instagram"></i>
                          </Link>
                        </li>
                      </ul>
                      <div className="team-card-one__social__icon">
                        <i className="fa fa-share-alt"></i>
                      </div>
                    </div>
                  </div>
                  <div className="team-card-one__content">
                    <h3 className="team-card-one__title">
                      <Link to="#">Sarah Albert</Link>
                    </h3>

                    <p className="team-card-one__designation">Director</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        <section className=" section-padding--top about-three about-three--home-one mb-5">
          <div
            className="about-three__shape wow fadeInRight"
            data-wow-duration="1500ms"
            style={{ backgroundImage: `url(${BGImg7})` }}
          ></div>
          <div className="container">
            <div className="row gutter-y-60">
              <div className="col-lg-6">
                <div className="about-three__image">
                  <img
                    src={img3}
                    className="wow fadeInUp"
                    data-wow-duration="1500ms"
                    alt=""
                  />
                </div>
              </div>
              <div className="col-lg-6" style={{ display: 'flex', alignItems: 'center' }}>
                <div className="about-three__content">
                  <div className="section-title ">
                    <p className="section-title__text">{t('home_page.com_benifits')}</p>
                    <h2 className="section-title__title">
                      {t('home_page.title_txt_4')}
                    </h2>
                  </div>
                  <div className="about-three__text">
                    {t('home_page.sub_title_1')}
                  </div>
                  <ul className="about-three__list">
                    <li className="about-three__list__item">
                      <div className="about-three__list__icon">
                        <i className="icon-cloud"></i>
                      </div>
                      <div className="about-three__list__content">
                        <h3 className="about-three__list__title">
                          <Link to="cyber-security">{t('home_page.cloud_service')}</Link>
                        </h3>
                        <p className="about-three__list__text">
                          {t('home_page.sub_title_2')}
                        </p>
                      </div>
                    </li>
                    <li className="about-three__list__item">
                      <div className="about-three__list__icon">
                        <i className="icon-group"></i>
                      </div>
                      <div className="about-three__list__content">
                        <h3 className="about-three__list__title">
                          <Link to="/team">{t('home_page.expert_team')}</Link>
                        </h3>
                        <p className="about-three__list__text">
                          {t('home_page.sub_title_2')}
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <section className="section-padding--top section-padding--bottom">
          <div className="container">
            <div className="section-title text-center">
              <p className="section-title__text">Direct from the Blog Posts</p>
              <h2 className="section-title__title">
                Checkout Our Latest <br />
                News & Articles
              </h2>
            </div>
            <div className="row gutter-y-30">
              <div
                className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="000ms"
              >
                <div className="blog-card-one">
                  <div className="blog-card-one__image">
                    <img src="assets/images/blog/blog-1-1.jpg" alt="" />
                    <Link to="/blog-details"></Link>
                  </div>
                  <div className="blog-card-one__content">
                    <div className="blog-card-one__meta">
                      <div className="blog-card-one__date">
                        <i
                          className="fa fa-calendar-alt"
                          aria-hidden="true"
                        ></i>
                        July, 25, 2022
                      </div>
                      <Link to="/blog" className="blog-card-one__category">
                        Designer
                      </Link>
                    </div>
                    <h3 className="blog-card-one__title">
                      <Link to="/blog-details">
                        Web design done Delightful Visualization Examples
                      </Link>
                    </h3>
                    <Link to="/blog-details" className="blog-card-one__more">
                      Read More
                      <i className="fa fa-arrow-right"></i>
                    </Link>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="100ms"
              >
                <div className="blog-card-one">
                  <div className="blog-card-one__image">
                    <img src="assets/images/blog/blog-1-2.jpg" alt="" />
                    <Link to="/blog-details"></Link>
                  </div>
                  <div className="blog-card-one__content">
                    <div className="blog-card-one__meta">
                      <div className="blog-card-one__date">
                        <i
                          className="fa fa-calendar-alt"
                          aria-hidden="true"
                        ></i>
                        July, 25, 2022
                      </div>
                      <Link to="/blog" className="blog-card-one__category">
                        Graphic
                      </Link>
                    </div>
                    <h3 className="blog-card-one__title">
                      <Link to="/blog-details">
                        Technology Support Allows Erie non-profit to Serve
                      </Link>
                    </h3>
                    <Link to="/blog-details" className="blog-card-one__more">
                      Read More
                      <i className="fa fa-arrow-right"></i>
                    </Link>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="200ms"
              >
                <div className="blog-card-one">
                  <div className="blog-card-one__image">
                    <img src="assets/images/blog/blog-1-3.jpg" alt="" />
                    <Link to="/blog-details"></Link>
                  </div>
                  <div className="blog-card-one__content">
                    <div className="blog-card-one__meta">
                      <div className="blog-card-one__date">
                        <i
                          className="fa fa-calendar-alt"
                          aria-hidden="true"
                        ></i>
                        July, 25, 2022
                      </div>
                      <Link to="/blog" className="blog-card-one__category">
                        SEO
                      </Link>
                    </div>
                    <h3 className="blog-card-one__title">
                      <Link to="/blog-details">
                        Software Makes Your Profit Double if You Scale Properly
                      </Link>
                    </h3>
                    <Link to="/blog-details" className="blog-card-one__more">
                      Read More
                      <i className="fa fa-arrow-right"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        <section className="cta-one">
          <div className="container">
            <div
              className="cta-one__inner text-center wow fadeInUp"
              data-wow-duration="1500ms"
            >
              <div className="cta-one__circle"></div>
              <div className="section-title ">
                <p className="section-title__text">
                  {t('home_page.title_1')}
                </p>
                <h2 className="section-title__title section-title__title--light">
                  {t('home_page.title_2')}
                </h2>
              </div>
              <Link
                to="/contact"
                className="thm-btn thm-btn--light cta-one__btn"
              >
                <span>{t('home_page.start_now')}</span>
              </Link>
            </div>
          </div>
        </section>
        {ytShow && (
          <div className="YouTubePopUp-Wrap">
            <div className="YouTubePopUp-Content">
              <span
                className="YouTubePopUp-Close"
                onClick={() => setytShow(false)}
              ></span>
              <iframe
                src="https://www.youtube.com/embed/rzfmZC3kg3M?autoplay=1"
                title="ytvideo"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        )}
      </>
    );
}

export default Home